export { ICharacter } from './character.interface';
export { CharacterCoreModule } from './character-core.module';
export { CharacterCoreService } from './character-core.service';
